import React from "react";
import classnames from "classnames";

import CardContainer from "@vahak/core/dist/components/responsive-container/ResponsiveContainer";
import { ga4sendEvent } from "@vahak/core/dist/_services/user-analytics.service";
import {
    GA4EventNames,
    GA4HomePageMeetTransportServiceProvidersEventValues
} from "@vahak/core/dist/constants/event-names";

import { Company } from "@vahak/core/dist/custom-types/company";
import TransporterCard from "../../cards/transporter-card/TransporterCard";

import cardStyles from "./searchResultsContainer.module.scss";

export interface SearchResultsProps {
    data?: Company[];
    className?: string;
    id?: string;
}

const SearchResults = ({ data, className, id }: SearchResultsProps) => {
    return (
        <CardContainer className={classnames(className, cardStyles.cardWrapperContainer)} id={id}>
            {data?.length &&
                data?.map((d, i) => {
                    return (
                        d?.name && (
                            <div key={i} className={classnames(cardStyles.cardWrapper)}>
                                <TransporterCard
                                    key={i}
                                    companyName={d.name}
                                    logo={d.logo}
                                    jobTitle={d.service_type}
                                    totalConnections={d.total_connections}
                                    totalViews={d.total_views}
                                    companyRunningFrom={d.years_in_business}
                                    companyLocation={`${d.city_name}, ${d.state_name}`}
                                    isAadharVerified={d.is_aadhaar_verified!}
                                    isGstVerified={d.is_gst_verified!}
                                    companyId={d.company_identity}
                                    ratings={d.rating}
                                    companyPhoneNumber={d.phone_number}
                                    onGetContactDetailsCtaClick={() => {
                                        ga4sendEvent(
                                            GA4EventNames.Homepage_meet_india_transporter_change_city_after_selection,
                                            {
                                                value: GA4HomePageMeetTransportServiceProvidersEventValues.get_contact_details
                                            }
                                        );
                                    }}
                                />
                            </div>
                        )
                    );
                })}
        </CardContainer>
    );
};

export default React.memo(SearchResults);
